"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var components_1 = require("@athena-portal/components");
var FieldDisplay_1 = require("../../components/FieldDisplay");
var LookupFieldDisplay_1 = require("../../components/LookupFieldDisplay");
var Tree_1 = require("../../components/Tree");
var InsuredPropertyTree = /** @class */ (function (_super) {
    __extends(InsuredPropertyTree, _super);
    function InsuredPropertyTree(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            residencyUsage: ""
        };
        return _this;
    }
    InsuredPropertyTree.prototype.render = function () {
        var _a;
        if (this.props.interaction && ((_a = this.props.interaction.realEstate) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            var realEstate = this.props.interaction.realEstate[0];
            var installedSmartHomeSystems = this.getInstalledSmartHomeSystems(realEstate.installedSmartHomeSystems);
            return ((0, jsx_runtime_1.jsxs)(Tree_1.Tree, { label: realEstate.address.fullAddress, children: [(0, jsx_runtime_1.jsx)(LookupFieldDisplay_1.LookupFieldDisplay, { label: "Property type & kind", type: "realEstateTypeSubType", id: realEstate.realEstateTypeSubType }), (0, jsx_runtime_1.jsx)(FieldDisplay_1.FieldDisplay, { label: "No. of Bedrooms", value: realEstate.bedroomCount }), (0, jsx_runtime_1.jsx)(FieldDisplay_1.FieldDisplay, { label: "No. of Bathrooms", value: realEstate.bathroomCount }), (0, jsx_runtime_1.jsx)(FieldDisplay_1.FieldDisplay, { label: "Wall construction", value: realEstate.externalWallMaterial.toLowerCase() }), (0, jsx_runtime_1.jsx)(FieldDisplay_1.FieldDisplay, { label: "Roof construction", value: realEstate.roofMaterial.toLowerCase() }), (0, jsx_runtime_1.jsx)(FieldDisplay_1.FieldDisplay, { label: "Year Property built", value: realEstate.yearBuilt }), installedSmartHomeSystems.length > 1 &&
                        (0, jsx_runtime_1.jsx)(FieldDisplay_1.FieldDisplay, { label: "Smart Home Systems", value: installedSmartHomeSystems.substring(0, installedSmartHomeSystems.length - 2) }), (0, jsx_runtime_1.jsx)(LookupFieldDisplay_1.LookupFieldDisplay, { label: "Who live at the property", type: "residencyUsage", id: realEstate.residentsType }), (0, jsx_runtime_1.jsx)(FieldDisplay_1.FieldDisplay, { label: "No. of Adults", value: realEstate.adultFamilyMemberCount }), (0, jsx_runtime_1.jsx)(FieldDisplay_1.FieldDisplay, { label: "No. of Children", value: realEstate.numberOfChildren })] }));
        }
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    };
    InsuredPropertyTree.prototype.getInstalledSmartHomeSystems = function (installedSystems) {
        var wording = "";
        if (installedSystems) {
            if (installedSystems.remoteHeatingControl) {
                wording = wording.concat("Remote Heating Control, ");
            }
            if (installedSystems.securityCamera) {
                wording = wording.concat("Security Camera, ");
            }
            if (installedSystems.waterLeakDetector) {
                wording = wording.concat("Water Leak Detector, ");
            }
            if (installedSystems.waterShutOffValve) {
                wording = wording.concat("Water Shutoff Valve, ");
            }
        }
        return wording;
    };
    InsuredPropertyTree = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], InsuredPropertyTree);
    return InsuredPropertyTree;
}(React.Component));
exports.default = InsuredPropertyTree;
//# sourceMappingURL=InsuredPropertyTree.js.map